var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard2Img(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 29,
    fill: "#A8A8A8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AI QUIZ BOOSTER",
    clipPath: "url(#clip0_13_7334)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 8804,
    transform: "translate(-1036 -2222)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 64",
    opacity: 0.2,
    filter: "url(#filter0_f_13_7334)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -101.5,
    cy: 330.5,
    rx: 374.5,
    ry: 395.5,
    transform: "rotate(90 -101.5 330.5)",
    fill: "#FFBB00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 237858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main",
    opacity: 0.9975,
    filter: "url(#filter1_d_13_7334)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -59.8125,
    y: -38,
    width: 546.91,
    height: 265.77,
    rx: 19,
    fill: "white",
    fillOpacity: 0.01,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    id: "span.lqd-bg-layer"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -59.8125,
    y: -38,
    width: 546.91,
    height: 265.77,
    rx: 19,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.24334 1.13521C3.37461 1.00394 3.55264 0.930194 3.73828 0.930176H18.4383C18.6239 0.930212 18.8019 1.00398 18.9332 1.13525L25.2332 7.43525C25.3645 7.56651 25.4382 7.74454 25.4383 7.93018V28.2302C25.4383 28.4158 25.3645 28.5939 25.2332 28.7251C25.102 28.8564 24.9239 28.9302 24.7383 28.9302H3.73828C3.55264 28.9302 3.37461 28.8564 3.24334 28.7251C3.11207 28.5939 3.0383 28.4158 3.03828 28.2302V10.7302H0.938281C0.752635 10.7302 0.574609 10.6564 0.443338 10.5251C0.312067 10.3939 0.2383 10.2158 0.238281 10.0302V5.13018C0.2383 4.94453 0.312067 4.76648 0.443338 4.63521C0.574609 4.50394 0.752635 4.43019 0.938281 4.43018H3.03828V1.63018C3.0383 1.44453 3.11207 1.26648 3.24334 1.13521ZM17.7383 2.33018H4.43828V4.43018H14.2383C14.4239 4.43019 14.602 4.50394 14.7332 4.63521C14.8645 4.76648 14.9383 4.94453 14.9383 5.13018V10.0302C14.9383 10.2158 14.8645 10.3939 14.7332 10.5251C14.602 10.6564 14.4239 10.7302 14.2383 10.7302H4.43828V27.5302H24.0383V8.63018H18.4383C18.2526 8.63016 18.0746 8.55641 17.9433 8.42514C17.8121 8.29387 17.7383 8.11582 17.7383 7.93018V2.33018ZM23.0484 7.23018L19.1383 3.32002V7.23018H23.0484ZM13.5383 5.83018H1.63828V9.33018H13.5383V5.83018ZM7.23828 12.1302C7.05264 12.1302 6.87461 12.2039 6.74334 12.3352C6.61207 12.4665 6.5383 12.6445 6.53828 12.8302V17.0302C6.5383 17.2158 6.61207 17.3939 6.74334 17.5251C6.87461 17.6564 7.05264 17.7302 7.23828 17.7302H21.2383C21.4239 17.7302 21.602 17.6564 21.7332 17.5251C21.8645 17.3939 21.9383 17.2158 21.9383 17.0302V12.8302C21.9383 12.6445 21.8645 12.4665 21.7332 12.3352C21.602 12.2039 21.4239 12.1302 21.2383 12.1302H7.23828ZM7.93828 16.3302V13.5302H20.5383V16.3302H7.93828ZM6.74334 18.6352C6.87461 18.5039 7.05264 18.4302 7.23828 18.4302H14.9383C15.1239 18.4302 15.302 18.5039 15.4332 18.6352C15.5645 18.7665 15.6383 18.9445 15.6383 19.1302V25.4302C15.6383 25.6158 15.5645 25.7939 15.4332 25.9251C15.302 26.0564 15.1239 26.1302 14.9383 26.1302H7.23828C7.05264 26.1302 6.87461 26.0564 6.74334 25.9251C6.61207 25.7939 6.5383 25.6158 6.53828 25.4302V19.1302C6.5383 18.9445 6.61207 18.7665 6.74334 18.6352ZM14.2383 19.8302H7.93828V24.7302H14.2383V19.8302ZM16.5433 18.6352C16.6746 18.5039 16.8526 18.4302 17.0383 18.4302H21.2383C21.4239 18.4302 21.602 18.5039 21.7332 18.6352C21.8645 18.7665 21.9383 18.9445 21.9383 19.1302V25.4302C21.9383 25.6158 21.8645 25.7939 21.7332 25.9251C21.602 26.0564 21.4239 26.1302 21.2383 26.1302H17.0383C16.8526 26.1302 16.6746 26.0564 16.5433 25.9251C16.4121 25.7939 16.3383 25.6158 16.3383 25.4302V19.1302C16.3383 18.9445 16.4121 18.7665 16.5433 18.6352ZM20.5383 24.7302V19.8302H17.7383V24.7302H20.5383Z",
    fill: "url(#paint0_linear_13_7334)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_13_7334",
    x: -901.1,
    y: -448.1,
    width: 1599.2,
    height: 1557.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 202.05,
    result: "effect1_foregroundBlur_13_7334"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13_7334",
    x: -103.812,
    y: -78,
    width: 634.91,
    height: 353.77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.341176 0 0 0 0 0.729412 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_7334"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_7334",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_7334",
    x1: 26.8383,
    y1: 0.930177,
    x2: 1.63828,
    y2: 26.1302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD136D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED839E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_7334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 8804,
    fill: "white",
    transform: "translate(-1036 -2222)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2Img);
export default __webpack_public_path__ + "static/media/card2Img.45fd81fd086558ee6bc2f43e1417b999.svg";
export { ForwardRef as ReactComponent };